import { yup } from 'common/validation/initYup';
import { ValidationSchema } from 'common/validation/ValidationSchema';
import { Type, Transform, plainToClass, classToPlain } from 'class-transformer';
import { TypeTransformDecimal } from 'common/dto/shared/types/TypeTransformDecimal';
import { Decimal } from 'decimal.js-light';
import { ApiProperty } from '@nestjs/swagger';
import type { IDto, IDtoPartial } from 'common/dto/shared/DtoInterfaces';
import { GenerateDto } from "cli/generate/decorators/GenerateDecorators";
import { SchemaLabel, SchemaPageNumber, SchemaPageSize } from "cli/generate/decorators/SchemaDecorators";
import { ColumnSortDirections } from "client/ui/table/TableColumnSort";



@GenerateDto()
class ContractDocumentQuery {
    @SchemaPageNumber()
    page!: number;
    @SchemaPageSize()
    pageSize!: number;
    @SchemaLabel("Ordinamento")
    orderBy?: string = 'createdAt';
    @SchemaLabel("Direzione di Ordinamento")
    orderByDirection?: ColumnSortDirections = ColumnSortDirections.descend;

    @SchemaLabel('ID Contratto')
    contractId?: number | null;
}

/**
 * Rappresentazione DTO della classe ContractDocumentQuery 
 * Hash: 4733da58698c4e6a6a24806b4b4b6dc8
 */
@ValidationSchema(() => ContractDocumentQuerySchema)
export class ContractDocumentQueryDto {
  @ApiProperty({ required: false, type: Number, description: 'Numero di pagina' })
  page!: number;
  @ApiProperty({ required: false, type: Number, description: 'Dimensione pagina' })
  pageSize!: number;
  @ApiProperty({ required: false, type: String, description: 'Ordinamento' })
  orderBy?: string | undefined = 'createdAt';
  @ApiProperty({ required: false, enum: ['ASC', 'DESC'], description: 'Direzione di Ordinamento' })
  orderByDirection?: ColumnSortDirections | undefined = ColumnSortDirections.descend;
  @ApiProperty({ required: false, type: Number, description: 'ID Contratto' })
  contractId?: number | null | undefined;

  /** Proprietà che identifica i DTO */
  readonly __dto!: any;

  /**
   * Crea una nuova istanza con i valori forniti
   */
  constructor(values?: IDtoPartial<ContractDocumentQueryDto>) {
    if (values != null) {
      Object.assign(this, values instanceof ContractDocumentQueryDto ? values : plainToClass(ContractDocumentQueryDto, values));
    }
  }

  async validate(options?: any) {
    const validated = await ContractDocumentQuerySchema.validate(classToPlain(this), options);
    return new ContractDocumentQueryDto(validated);
  }
}

export const ContractDocumentQuerySchema = yup
  .object({
    page: yup.number().default(1).min(1).integer().positive().label('Numero di pagina'),
    pageSize: yup.number().default(20).min(10).max(50).integer().positive().label('Dimensione pagina'),
    orderBy: yup.string().default('createdAt').label('Ordinamento'),
    orderByDirection: yup.string().oneOfEnum(ColumnSortDirections).default(ColumnSortDirections.descend).label('Direzione di Ordinamento'),
    contractId: yup.number().nullable().label('ID Contratto')
  })
  .noUnknown()
  .meta({ schemaName: "ContractDocumentQuerySchema" })
  .required();
